<template>
  <div class="sidebar" id="sidebar">
    <div class="scroll-area overflow-y-auto">
      <div class="sidebar-inner slimscroll">
        <div class="header-left logo-light">
          <router-link to="/admin-template/admin-index" class="logo">
            <img src="@/assets/admin_img/logo.png" alt="Logo" />
          </router-link>
          <router-link to="/admin-template/admin-index" class="logo logo-small">
            <img
              src="@/assets/admin_img/logo-small.png"
              alt="Logo"
              width="30"
              height="30"
            />
          </router-link>
        </div>

        <div class="header-left logo-dark">
          <router-link to="/admin-template/admin-index" class="logo">
            <img src="@/assets/admin_img/logo-dark.png" alt="Logo" />
          </router-link>
          <router-link to="/admin-template/admin-index" class="logo logo-small">
            <img
              src="@/assets/admin_img/logo-small-dark.png"
              alt="Logo"
              width="30"
              height="30"
            />
          </router-link>
        </div>

        <div id="sidebar-menu" class="sidebar-menu">
          <ul>
            <li class="menu-title">Main Menu</li>
            <li :class="{ active: $route.path === '/admin-template/admin-index' }">
              <router-link :to="{ path: '/admin-template/admin-index' }">
                <i class="bx bx-category"></i> <span>Dashboard</span>
              </router-link>
            </li>
            <li
              class="submenu"
              v-bind:class="{
                active:
                  currentPath == 'users' ||
                  currentPath == 'block-user' ||
                  currentPath == 'report-user' ||
                  currentPath == 'invite-user',
              }"
            >
              <a
                href="#sidebarUsers"
                data-bs-toggle="collapse"
                role="button"
                aria-expanded="false"
                aria-controls="sidebarUsers"
                :class="{ active: UsersMenu, subdrop: UsersMenu }"
              >
                <i class="bx bx-user"></i>
                <span>Users</span>
                <span class="menu-arrow"></span>
              </a>
              <ul class="collapse" id="sidebarUsers" :class="{ show: UsersMenu }">
                <li
                  v-bind:class="{
                    active: currentPath == '/users',
                  }"
                >
                  <router-link to="/admin-template/users"
                    ><i class="bx bxs-circle me-1"></i>Users List</router-link
                  >
                </li>
                <li
                  v-bind:class="{
                    active: currentPath == '/block-user',
                  }"
                >
                  <router-link to="/admin-template/block-user"
                    ><i class="bx bxs-circle me-1"></i>Blocked Users</router-link
                  >
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == '/report-user',
                    }"
                    to="/admin-template/report-user"
                    ><i class="bx bxs-circle me-1"></i>Reported Users</router-link
                  >
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == '/invite-user',
                    }"
                    to="/admin-template/invite-user"
                    ><i class="bx bxs-circle me-1"></i>Invited Users</router-link
                  >
                </li>
              </ul>
            </li>
            <li :class="{ active: $route.path === '/admin-template/chat' }">
              <router-link to="/admin-template/chat">
                <i class="bx bx-message-square-detail"></i> <span>Chat</span>
              </router-link>
            </li>
            <li :class="{ active: $route.path === '/admin-template/call' }">
              <router-link to="/admin-template/call">
                <i class="bx bx-phone"></i> <span>Calls</span>
              </router-link>
            </li>
            <li
              v-bind:class="{
                active: currentPath == 'stories',
              }"
            >
              <router-link to="/admin-template/stories"
                ><i class="bx bx-stop-circle"></i> <span> Stories </span></router-link
              >
            </li>
            <li class="menu-title">Settings</li>
            <li
              class="submenu"
              v-bind:class="{
                active:
                  currentPath == 'profile-settings' ||
                  currentPath == 'website-settings' ||
                  currentPath == 'system-settings' ||
                  currentPath == 'invite-settings' ||
                  currentPath == 'notification-settings' ||
                  currentPath == 'localization-settings' ||
                  currentPath == 'appearance-settings' ||
                  currentPath == 'social-auth' ||
                  currentPath == 'email-settings' ||
                  currentPath == 'sms-settings' ||
                  currentPath == 'otp' ||
                  currentPath == 'authentication-settings' ||
                  currentPath == 'storage' ||
                  currentPath == 'ban-address' ||
                  currentPath == 'gdpr' ||
                  currentPath == 'language' ||
                  currentPath == 'language-translate' ||
                  currentPath == 'language-app' ||
                  currentPath == 'language-admin',
              }"
            >
              <a
                href="#sidebarSettings"
                data-bs-toggle="collapse"
                role="button"
                aria-expanded="false"
                aria-controls="sidebarSettings"
                :class="{ active: SettingsMenu, subdrop: SettingsMenu }"
              >
                <i class="bx bx-cog"></i>
                <span>Settings</span><span class="badge setting-new">New</span>
                <span class="menu-arrow"></span>
              </a>
              <ul class="collapse" id="sidebarSettings" :class="{ show: SettingsMenu }">
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'profile-settings',
                    }"
                    to="/admin-template/profile-settings"
                    ><i class="bx bxs-circle me-1"></i>Profile Setting</router-link
                  >
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'website-settings',
                    }"
                    to="/admin-template/website-settings"
                    ><i class="bx bxs-circle me-1"></i>Website Setting
                  </router-link>
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'system-settings',
                    }"
                    to="/admin-template/system-settings"
                    ><i class="bx bxs-circle me-1"></i>System Setting
                  </router-link>
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'notification-settings',
                    }"
                    to="/admin-template/notification-settings"
                    ><i class="bx bxs-circle me-1"></i>Notification
                  </router-link>
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'localization-settings',
                    }"
                    to="/admin-template/localization-settings"
                    ><i class="bx bxs-circle me-1"></i>Localization
                  </router-link>
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'appearance-settings',
                    }"
                    to="/admin-template/appearance-settings"
                    ><i class="bx bxs-circle me-1"></i>Appearance
                  </router-link>
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'social-auth',
                    }"
                    to="/admin-template/social-auth"
                    ><i class="bx bxs-circle me-1"></i>Social Authentication
                  </router-link>
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'email-settings',
                    }"
                    to="/admin-template/email-settings"
                    ><i class="bx bxs-circle me-1"></i>Email Setting
                  </router-link>
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'sms-settings',
                    }"
                    to="/admin-template/sms-settings"
                    ><i class="bx bxs-circle me-1"></i>SMS Setting
                  </router-link>
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'otp',
                    }"
                    to="/admin-template/otp"
                    ><i class="bx bxs-circle me-1"></i>OTP Setting
                  </router-link>
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'authentication-settings',
                    }"
                    to="/admin-template/authentication-settings"
                    ><i class="bx bxs-circle me-1"></i>Authentication
                  </router-link>
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'storage',
                    }"
                    to="/admin-template/storage"
                    ><i class="bx bxs-circle me-1"></i>Storage
                  </router-link>
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'ban-address',
                    }"
                    to="/admin-template/ban-address"
                    ><i class="bx bxs-circle me-1"></i>Ban IP Address
                  </router-link>
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'gdpr',
                    }"
                    to="/admin-template/gdpr"
                    ><i class="bx bxs-circle me-1"></i>GDPR (Cookies)
                  </router-link>
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active:
                        currentPath == 'language' ||
                        currentPath == 'language-translate' ||
                        currentPath == 'language-app' ||
                        currentPath == 'language-admin',
                    }"
                    to="/admin-template/language"
                    ><i class="bx bxs-circle me-1"></i>Language
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="menu-title">Others</li>
            <li
              v-bind:class="{
                active: currentPath == 'blank-page',
              }"
            >
              <router-link to="/admin-template/blank-page"
                ><i class="bx bx-file-blank"></i> <span>Blank Page</span></router-link
              >
            </li>
            <li
              v-bind:class="{
                active: currentPath == 'vector-maps',
              }"
            >
              <router-link to="/admin-template/vector-maps"
                ><i class="bx bx-map-alt"></i> <span>Google Map</span></router-link
              >
            </li>
            <li
              v-bind:class="{
                active: currentPath == 'components',
              }"
            >
              <router-link to="/admin-template/components"
                ><i class="bx bx-grid-alt"></i> <span>Components</span></router-link
              >
            </li>
            <li
              class="submenu"
              v-bind:class="{
                active:
                  currentPath == 'form-basic-inputs' ||
                  currentPath == 'form-input-groups' ||
                  currentPath == 'form-horizontal' ||
                  currentPath == 'form-vertical' ||
                  currentPath == 'form-mask' ||
                  currentPath == 'form-validation',
              }"
            >
              <a
                href="#sidebarForms"
                data-bs-toggle="collapse"
                role="button"
                aria-expanded="false"
                aria-controls="sidebarForms"
                :class="{ active: FormsMenu, subdrop: FormsMenu }"
                ><i class="bx bx-layout"></i>
                <span> Forms <span class="menu-arrow"></span></span
              ></a>
              <ul class="collapse" id="sidebarForms" :class="{ show: FormsMenu }">
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'form-basic-inputs',
                    }"
                    to="/admin-template/form-basic-inputs"
                    ><i class="bx bxs-circle me-1"></i>Basic Inputs</router-link
                  >
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'form-input-groups',
                    }"
                    to="/admin-template/form-input-groups"
                    ><i class="bx bxs-circle me-1"></i>Input Groups</router-link
                  >
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'form-horizontal',
                    }"
                    to="/admin-template/form-horizontal"
                    ><i class="bx bxs-circle me-1"></i>Horizontal Form</router-link
                  >
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'form-vertical',
                    }"
                    to="/admin-template/form-vertical"
                    ><i class="bx bxs-circle me-1"></i>Vertical Form
                  </router-link>
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'form-mask',
                    }"
                    to="/admin-template/form-mask"
                    ><i class="bx bxs-circle me-1"></i>Form Mask</router-link
                  >
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'form-validation',
                    }"
                    to="/admin-template/form-validation"
                    ><i class="bx bxs-circle me-1"></i>Form Validation
                  </router-link>
                </li>
              </ul>
            </li>
            <li
              class="submenu"
              v-bind:class="{
                active: currentPath == 'tables-basic' || currentPath == 'data-tables',
              }"
            >
              <a
                href="#sidebarTables"
                data-bs-toggle="collapse"
                role="button"
                aria-expanded="false"
                aria-controls="sidebarTables"
                :class="{ active: TablesMenu, subdrop: TablesMenu }"
                ><i class="bx bx-layout"></i>
                <span> Tables <span class="menu-arrow"></span></span
              ></a>
              <ul class="collapse" id="sidebarTables" :class="{ show: TablesMenu }">
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'tables-basic',
                    }"
                    to="/admin-template/tables-basic"
                    ><i class="bx bxs-circle me-1"></i>Basic Tables
                  </router-link>
                </li>
                <li>
                  <router-link
                    v-bind:class="{
                      active: currentPath == 'data-tables',
                    }"
                    to="/admin-template/data-tables"
                    ><i class="bx bxs-circle me-1"></i>Data Table
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);"
                ><i class="bx bx-code"></i> <span>Multi Level</span>
                <span class="menu-arrow"></span
              ></a>
              <ul style="display: none">
                <li class="submenu">
                  <a href="javascript:void(0);">
                    <span>Level 1</span> <span class="menu-arrow"></span
                  ></a>
                  <ul style="display: none">
                    <li>
                      <a href="javascript:void(0);"><span>Level 2</span></a>
                    </li>
                    <li class="submenu">
                      <a href="javascript:void(0);">
                        <span> Level 2</span> <span class="menu-arrow"></span
                      ></a>
                      <ul style="display: none">
                        <li><a href="javascript:void(0);">Level 3</a></li>
                        <li><a href="javascript:void(0);">Level 3</a></li>
                      </ul>
                    </li>
                    <li>
                      <a href="javascript:void(0);"> <span>Level 2</span></a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="javascript:void(0);"> <span>Level 1</span></a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="flags-group">
      <div class="dropdown has-arrow flag-nav">
        <a
          class="nav-link dropdown-toggle"
          data-bs-toggle="dropdown"
          href="javascript:;"
          role="button"
          aria-expanded="false"
        >
          <img src="@/assets/admin_img/flag/flag-01.png" class="me-2" alt="flag" /><span
            >English</span
          >
        </a>
        <div class="dropdown-menu dropdown-menu-right">
          <a href="javascript:void(0);" class="dropdown-item">
            <img src="@/assets/admin_img/flag/flag-01.png" alt="flag" /><span
              >English</span
            >
          </a>
          <a href="javascript:void(0);" class="dropdown-item">
            <img src="@/assets/admin_img/flag/flag-02.png" alt="flag" /><span
              >French</span
            >
          </a>
          <a href="javascript:void(0);" class="dropdown-item">
            <img src="@/assets/admin_img/flag/flag-03.png" alt="flag" /><span
              >Spanish</span
            >
          </a>
          <a href="javascript:void(0);" class="dropdown-item">
            <img src="@/assets/admin_img/flag/flag-04.png" alt="flag" /><span
              >German</span
            >
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      UsersMenus: false,
      SettingsMenus: false,
      FormsMenus: false,
      TablesMenus: false,
      settings: {
        suppressScrollX: true,
      },
      activeClass: "active",
    };
  },
  methods: {
    scrollHanle(evt) {},
  },
  components: {
  },
  computed: {
    currentPath() {
      return this.$route.name;
    },
    UsersMenu() {
      return (
        this.$route.name == "users" ||
        this.$route.name == "block-user" ||
        this.$route.name == "report-user" ||
        this.$route.name == "invite-user"
      );
    },
    SettingsMenu() {
      return (
        this.$route.name == "profile-settings" ||
        this.$route.name == "website-settings" ||
        this.$route.name == "system-settings" ||
        this.$route.name == "notification-settings" ||
        this.$route.name == "localization-settings" ||
        this.$route.name == "appearance-settings" ||
        this.$route.name == "social-auth" ||
        this.$route.name == "email-settings" ||
        this.$route.name == "sms-settings" ||
        this.$route.name == "otp" ||
        this.$route.name == "authentication-settings" ||
        this.$route.name == "storage" ||
        this.$route.name == "ban-address" ||
        this.$route.name == "gdpr" ||
        this.$route.name == "language" ||
        this.$route.name == "language-translate" ||
        this.$route.name == "language-app" ||
        this.$route.name == "language-admin"
      );
    },

    FormsMenu() {
      return (
        this.$route.name == "form-basic-inputs" ||
        this.$route.name == "form-input-groups" ||
        this.$route.name == "form-horizontal" ||
        this.$route.name == "form-vertical" ||
        this.$route.name == "form-mask" ||
        this.$route.name == "form-validation"
      );
    },
    TablesMenu() {
      return this.$route.name == "tables-basic" || this.$route.name == "data-tables";
    },
  },
};
</script>
